module.exports = __webpack_public_path__ + "static/img/pack.add41b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pack.png
// module id = TxjT
// module chunks = 64